module.exports = __webpack_public_path__ + "static/img/greenLogo.1a09986.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/greenLogo.png
// module id = uREz
// module chunks = 1